import GetUploadTokenForFormPhotoWithoutAuth from "./getUploadTokenForFormPhotoWithoutAuth";
import GetEventApplicationFormWihoutAuth from "./getEventApplicationFormWihoutAuth";
import CancelRequestForUpdateCompany from "./cancelRequestForUpdateCompany";
import RemoveCommercialOpportunity from "./removeCommercialOpportunity";
import UpdateRequestForEditCompany from "./updateRequestForEditCompany";
import EventApplicationWithoutAuth from "./eventApplicationWihouthAuth";
import CancelProfileUpdateRequest from "./cancelProfileUpdateRequest";
import GetUploadTokenForFormPhoto from "./getUploadTokenForFormPhoto";
import GetThreetTokenWithoutCode from "./getThreetTokenWithoutCode";
import EditCommercialOpportunity from "./editCommercialOpportunity";
import GetParticipantActiveState from "./getParticipantActiveState";
import GetEventDetailWithoutAuth from "./getEventDetailWihoutAuth";
import NewCommercialOpportunity from "./newCommercialOpportunity";
import GetCommercialOpportunies from "./getCommercialOpportunies";
import CampaignCoverPhotoUpdate from "./campaignCoverPhotoUpdate";
import SendProfileUpdateRequest from "./sendProfileUpdateRequest";
import GetCompanyUpdateRequests from "./getCompanyUpdateRequests";
import GetThreetTokenForMembers from "./getThreetTokenForMembers";
import GetProfileUpdateRequest from "./getProfileUpdateRequests";
import GetThreetTokenForGuests from "./getThreetTokenForGuests";
import SendContactFormWithAuth from "./sendContactFormWithAuth";
import GetEventApplicationForm from "./getEventApplicationForm";
import GetAnnouncementDetail from "./getAnouncementDetail";
import DeleteCompanyRequest from "./deleteCompanyRequest";
import SetForgottenPassword from "./setForgottenPassword";
import CreateCompanyRequest from "./createCompanyRequest";
import GetEventsWithoutAuth from "./getEventsWithoutAuth";
import StartForgetPassword from "./startForgetPassword";
import GetBoardOfDirectors from "./getBoardOfDirectors";
import EditCompanyRequest from "./editCompanyRequest";
import GetMyOpportunities from "./getMyOpportunities";
import UploadProfilePhoto from "./uploadProfilePhoto";
import GetMyCompanyDetail from "./getMyCompanyDetail";
import UpdateCompanyPhoto from "./updateCompanyPhoto";
import GetMyNotifications from "./getMyNotifications";
import GetMemberTableInfo from "./getMemberTableInfo";
import DeleteNotification from "./deleteNotification";
import CreateCompanyPhoto from "./createCompanyLogo";
import GetCompanyProfile from "./getCompanyProfile";
import CheckForgotPWCode from "./checkForgotPWCode";
import GetInitialConfigs from "./getInitialConfigs";
import GetAboutPresident from "./getAboutPresident";
import GetNewsCategories from "./getNewsCategories";
import GetGuestTableInfo from "./getGuestTableInfo";
import GetPrivacyPolicy from "./getPrivacyPolicy";
import GetAnnouncements from "./getAnnouncements";
import GetMemberProfile from "./getMemberProfile";
import FinishMailVerify from "./finishMailVerify";
import GetOldPresidents from "./getOldPresidents";
import EventApplication from "./eventApplication";
import StartMailVerify from "./startMailVerify";
import DeleteMyAccount from "./deleteMyAccount";
import GetFeaturedData from "./getFeaturedData";
import GetMemberPolicy from "./getMemberPolicy";
import SendContactForm from "./sendContactForm";
import ChangePassword from "./changePassword";
import GetMyCompanies from "./getMyCompanies";
import GetEventDetail from "./getEventDetail";
import CompanySearch from "./companySearch";
import GetNewsDetail from "./getNewsDetail";
import GetUnreadCount from "./getUnreadCount";
import MarkAllAsRead from "./markAllAsRead";
import GetMyProfile from "./getMyProfile";
import RefreshToken from "./refreshToken";
import GetPositions from "./getPositions";
import GetCompanies from "./getCompanies";
import MarkAsRead from "./markAsRead";
import GetSectors from "./getSectors";
import GetAboutUs from "./getAboutUs";
import GetSearch from "./getSearch";
import GetEvents from "./getEvents";
import GetNews from "./getNews";
import GetKVKK from "./getKVKK";
import Logout from "./logout";
import Login from "./login";
import Me from "./me";

const actions = {
    GetUploadTokenForFormPhotoWithoutAuth,
    GetEventApplicationFormWihoutAuth,
    CancelRequestForUpdateCompany,
    UpdateRequestForEditCompany,
    RemoveCommercialOpportunity,
    EventApplicationWithoutAuth,
    GetUploadTokenForFormPhoto,
    CancelProfileUpdateRequest,
    GetEventDetailWithoutAuth,
    EditCommercialOpportunity,
    GetParticipantActiveState,
    GetThreetTokenWithoutCode,
    GetThreetTokenForMembers,
    NewCommercialOpportunity,
    GetCommercialOpportunies,
    GetCompanyUpdateRequests,
    SendProfileUpdateRequest,
    CampaignCoverPhotoUpdate,
    GetProfileUpdateRequest,
    GetThreetTokenForGuests,
    GetEventApplicationForm,
    SendContactFormWithAuth,
    GetAnnouncementDetail,
    DeleteCompanyRequest,
    GetEventsWithoutAuth,
    CreateCompanyRequest,
    SetForgottenPassword,
    StartForgetPassword,
    GetBoardOfDirectors,
    EditCompanyRequest,
    GetMyOpportunities,
    CreateCompanyPhoto,
    UpdateCompanyPhoto,
    GetMemberTableInfo,
    GetMyCompanyDetail,
    GetMyNotifications,
    UploadProfilePhoto,
    DeleteNotification,
    GetGuestTableInfo,
    GetNewsCategories,
    CheckForgotPWCode,
    GetInitialConfigs,
    GetAboutPresident,
    GetCompanyProfile,
    GetOldPresidents,
    GetAnnouncements,
    GetMemberProfile,
    GetPrivacyPolicy,
    EventApplication,
    FinishMailVerify,
    SendContactForm,
    StartMailVerify,
    GetMemberPolicy,
    DeleteMyAccount,
    GetFeaturedData,
    GetUnreadCount,
    GetEventDetail,
    ChangePassword,
    GetMyCompanies,
    MarkAllAsRead,
    GetNewsDetail,
    CompanySearch,
    RefreshToken,
    GetPositions,
    GetCompanies,
    GetMyProfile,
    MarkAsRead,
    GetAboutUs,
    GetSectors,
    GetSearch,
    GetEvents,
    GetKVKK,
    GetNews,
    Logout,
    Login,
    Me
};
export default actions;
